import React, { Component } from 'react'
import TableC from '../../../basicElement/TableC';
import { Button, Icon, InputNumber, Tooltip, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import format from '../../../shared/format';

export default class FTEQuoteRule extends Component {

    state = {
        annualData:[],
        nonBindAnnualData: [],
        params: {},
        fteDataTables: [],
        fteTableTypes: [],
        type: 'view',
        showAnnualData: false,
        serveFeeType: '',
    };

    componentDidMount() {
        const { evaluateRecordId } = this.props;
        this.queryServeFeeType(evaluateRecordId);
        this.setShowParams();
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId } = nextProps;
        this.queryServeFeeType(evaluateRecordId);
        this.setShowParams();
    }

    queryServeFeeType = (evaluateRecordId) => {
        if(!evaluateRecordId) return
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServeFeeType,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { serveFeeType } = res;
                this.setState({
                    serveFeeType,
                },() => {
                    this.loadData(evaluateRecordId, serveFeeType);
                })
            },
        };
        $.sendRequest(options);
    }

    loadData = (evaluateRecordId) => {
        const { serveFeeType } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateFteDataTables,
            data: { evaluateRecordId, serveFeeType },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, quotation, nonBindQuotation } = res;
                const { fteDataTables, fteTableTypes } = data;
                this.setState({
                    fteDataTables,
                    fteTableTypes,
                    annualData: quotation ? [quotation] : [],
                    nonBindAnnualData: nonBindQuotation ? [nonBindQuotation] : [],
                })
            }
        };
        $.sendRequest(options);
    }

    setShowParams = () => {
        const { record = {}, pageName } = this.props;
        const { talAuth, deptBoAuth, bdBaAuth, seniorUserAuth, finAuth } = record;
        const { curRole } = sessionStorage;
        let show = false;
        if (pageName === 'viewPage') {
            show = false;
        } else if (pageName === 'edit') {
            show = talAuth || deptBoAuth;
        } else if (pageName === 'view') {
            show = seniorUserAuth || talAuth || deptBoAuth || bdBaAuth || curRole === 'BDO' || curRole === 'BAL' || finAuth;
        }
        this.setState({
            showAnnualData: show,
        })
    }

    handleChange = (value, key, index, evaluateFteTableType) => {
        const { fteDataTables } = this.state;
        const fteDataColumns = fteDataTables.filter(el => el.evaluateFteTableType === evaluateFteTableType);
        const { datas } = fteDataColumns[0];
        datas[index][key] = value;
        this.setState({ fteDataTables });
    }

    getColumns = (evaluateFteTableType) => {
        const { fteDataTables, type } = this.state;
        const fteDataColumns = (fteDataTables || []).filter(el => el.evaluateFteTableType === evaluateFteTableType);
        const { columns } = fteDataColumns[0]; 
        const newColumns = columns.map(el => ({title: el}));  //将数组元素转换成对象
        newColumns.map(el => {    //通过表头名称，设置对应的取值字段
            switch (el.title) {
                case 'CRC(FTE/site/m)':
                    el.key = 'crcValue';            //表格数据的取值字段
                    el.editName = 'crcEditable';     //判断是否可编辑的字段
                    break;
                case 'PM(FTE/m)':
                    el.key = 'pmValue';
                    el.editName = 'pmEditable';
                    break;
                case '非盲-CRC(FTE/site/m)':
                    el.key = 'unBindCrcValue';
                    el.editName = 'unBindCrcEditable';
                    break;
                case '非盲-PM(FTE/m)':
                    el.key = 'unBindPmValue';
                    el.editName = 'unBindPmEditable';
                    break;
                case '基础管理(FTE/site/m)':
                    el.key = 'basicServeValue';
                    el.editName = 'basicServeEditable';
                    break;
                case '金额（不含税）小计/人民币':
                    el.key = 'totalValue';
                    break;
                case '总计金额（不含税）':
                    el.key = 'totalValue';
                    break;
                default:
                    el.key = 'fteDataTypeShow';
                    break;
            }
        })
        const tableColumns = newColumns.map(el => {
            const { title, key, editName } = el;
            return {
                title: title,
                dataIndex: key,
                key: key,
                width: 120,
                render: (text, record, index) => {
                    const { fteDataType, tipValue } = record;
                    const isAmount = key === 'totalValue' || fteDataType === 'DATA_TYPE_AMOUNT';
                    return (editName && record[editName] === 1 && type === 'edit') ? 
                            <InputNumber
                                placeholder='请输入'
                                style={{width: 100}}
                                precision={(fteDataType == 'DATA_TYPE_AVG_SITE' && key == 'basicServeValue') ? 0 : 2}
                                value={text}
                                onChange={value => this.handleChange(value, key, index, evaluateFteTableType)}
                            />
                            : (text ? ((tipValue && text == '该阶段平均FTE') ? <span>
                                {text}
                                <Tooltip overlayStyle={{ width: 180 }} placement="top" title={tipValue}>
                                    <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                                </Tooltip>
                            </span> : (isAmount ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : text)) : '-')
                    }
            }
        })
        return tableColumns
    }

    getAnnualColumns = (isBindAndNonBind = false) => {
        const columns = [
            {
                title: '客户名称',
                dataIndex: 'sponsorName',
                key: 'sponsorName',
                width: 100,
            }, 
            {
                title: '领域疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 100,
            }, 
            {
                title: '中心数',
                dataIndex: 'startSiteNum',
                key: 'startSiteNum',
                width: 100,
            }, 
            {
                title: '计划入组例数',
                dataIndex: 'randomCaseNum',
                key: 'randomCaseNum',
                width: 100,
            }, 
            {
                title: '项目周期（月）',
                dataIndex: 'investigationCycleMonthCount',
                key: 'investigationCycleMonthCount',
                width: 100,
            }, 
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}总价金额(不含税)/人民币`,
                dataIndex: 'evaluateTotalPrice',
                key: 'evaluateTotalPrice',
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, 
            {
                title: `${isBindAndNonBind ? '盲态服务' : ''}单例价格金额(不含税)/人民币`,
                dataIndex: 'evaluateUnitPrice',
                key: 'evaluateUnitPrice',
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, 
            {
                title: `项目${isBindAndNonBind ? '盲态服务' : ''}年产出（不含税）/人民币`,
                title: <span>{`项目${isBindAndNonBind ? '盲态服务' : ''}年产出（不含税）/人民币`}
                <Tooltip title={<span>
                    如果“随访期”≤24个月，那么项目年产出=总价金额（不含税）/((客户项目参数下入组期+治疗期+随访期)/12)/客户项目参数下“启动中心数””<br/>
                    如果“随访期”＞24个月，那么项目年产出=总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”
                </span>}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                dataIndex: 'investigationYearOutput',
                key: 'investigationYearOutput',
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, 
        ]
        return columns
    }

    getNoBindAnnualColumns = (isBindAndNonBind = false) => {
        const columns = [
            {
                title: "客户名称",
                key: "sponsorName",
                dataIndex: "sponsorName",
                width: 120,
            }, {
                title: "领域/疾病",
                key: "diseaseName",
                dataIndex: "diseaseName",
                width: 120,
            }, {
                title: "中心数",
                key: "startSiteNum",
                dataIndex: "startSiteNum",
                width: 100,
            }, {
                title: "计划入组例数",
                key: "randomCaseNum",
                dataIndex: "randomCaseNum",
                width: 100,
            }, {
                title: "项目周期（月）",
                key: "investigationCycleMonthCount",
                dataIndex: "investigationCycleMonthCount",
                width: 120,
            }, {
                title: <span>非盲CRC评估总FTE
                <Tooltip title={`${isBindAndNonBind ? '“非盲CRC月均FTE”*“非盲服务中心数”*（“入组期”月份数+“治疗期”月份数）' : '“非盲CRC月均FTE”*“非盲服务中心数”*（“入组期”月份数+“治疗期”月份数）'}`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "nonBindCrcTotalFte",
                dataIndex: "nonBindCrcTotalFte",
                width: 100,
            }, {
                title: <span>每例病人非盲工作评估FTE
                <Tooltip title={`非盲CRC评估总FTE/计划入组数`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "patientNonBindFte",
                dataIndex: "patientNonBindFte",
                width: 100,
            }, {
                title: "非盲CRC服务总价金额（不含税）/人民币",
                key: "nonBindCrcTotalPrice",
                dataIndex: "nonBindCrcTotalPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: "非盲PM服务总价金额（不含税）/人民币",
                key: "nonBindPmTotalPrice",
                dataIndex: "nonBindPmTotalPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: `${isBindAndNonBind ? '非盲服务' : ''}总价金额（不含税）/人民币`,
                key: "evaluateTotalPrice",
                dataIndex: "evaluateTotalPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: `${isBindAndNonBind ? '非盲服务' : ''}单例价格金额（不含税）/人民币`,
                key: "evaluateUnitPrice",
                dataIndex: "evaluateUnitPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: <span>{`项目${isBindAndNonBind ? '非盲服务' : ''}年产出（不含税）/人民币`}
                <Tooltip title={`${isBindAndNonBind ? '非盲服务总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”' : '总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”'}`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "investigationYearOutput",
                dataIndex: "investigationYearOutput",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }];
        return columns;
    };

    getDataSource = (evaluateFteTableType) => {
        const { fteDataTables } = this.state;
        const fteDataColumns = fteDataTables.filter(el => el.evaluateFteTableType === evaluateFteTableType);
        const { datas } = fteDataColumns[0];
        const dataSource = [];
        datas.map(el => {
            let text = '';
            switch (el.fteDataType) {
                case 'DATA_TYPE_AVG_FTE':
                    text = '该阶段平均FTE';
                    break;
                case 'DATA_TYPE_ESTIMATE_TIME':
                    text = '该阶段预计时长(m)';
                    break;
                case 'DATA_TYPE_AVG_SITE':
                    text = '该阶段平均site数量(site/m)';
                    break;
                case 'DATA_TYPE_TOTAL_FTE':
                    text = 'FTE小计';
                    break;
                case 'DATA_TYPE_AMOUNT':
                    text = '金额（不含税）小计/人民币';
                    break;
                // case 'DATA_TYPE_TOTAL_AMOUNT':
                //     text = '金额合计';
                //     break;
                default:
                    break;
            }
            dataSource.push({
                ...el,
                fteDataTypeShow: text,
            })
        });
        return dataSource
    }

    submit = () => {
        const { fteDataTables } = this.state;
        const { evaluateRecordId } = this.props;
        const list = fteDataTables.map(el => ({ datas: el.datas }));
        const filterList = [];
        let verify = false;   //校验必填判断
        list.map(el => {
            el.datas.map(data => {
                const {
                    basicServeEditable,
                    basicServeValue,
                    crcEditable,
                    crcValue,
                    pmEditable,
                    pmValue,
                    unBindCrcEditable,
                    unBindCrcValue,
                    unBindPmEditable,
                    unBindPmValue,
                } = data;
                if (basicServeEditable == 1 || crcEditable == 1 || pmEditable == 1 || unBindCrcEditable == 1 || unBindPmEditable == 1) {
                    filterList.push(data);
                }

                if ((basicServeEditable == 1 && basicServeValue != 0 && !basicServeValue) || (crcEditable == 1 && crcValue != 0  && !crcValue) || (pmEditable == 1 && pmValue != 0  && !pmValue) || (unBindCrcEditable == 1 && unBindCrcValue != 0  && !unBindCrcValue) || (unBindPmEditable == 1 && unBindPmValue != 0  && !unBindPmValue)) {
                    verify = true;
                }
            })
        })
        if (verify) {
            return message.warning('有未填项！')
        }
        let obj = {};
        filterList.map((el, index) => {
            obj[`evaluateFteDatas[${index}].fteTableType`] = el.fteTableType;
            obj[`evaluateFteDatas[${index}].fteDataType`] = el.fteDataType;
            obj[`evaluateFteDatas[${index}].crcValue`] = el.crcValue;
            obj[`evaluateFteDatas[${index}].pmValue`] = el.pmValue;
            obj[`evaluateFteDatas[${index}].unBindCrcValue`] = el.unBindCrcValue;
            obj[`evaluateFteDatas[${index}].unBindPmValue`] = el.unBindPmValue;
            obj[`evaluateFteDatas[${index}].basicServeValue`] = el.basicServeValue;
        })
        const options = {
            method: 'POST',
            url: API_URL.evaluate.saveEvaluateFteData,
            data: { 
                evaluateRecordId,
                ...obj
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.data);
                this.setState({
                    type: 'view',
                },() => {
                    this.loadData(evaluateRecordId);
                })
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { fteTableTypes, annualData, nonBindAnnualData, type, showAnnualData, serveFeeType } = this.state;
        const { showButn = true, evaluateRecordId } = this.props;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        return (
            <div>
                {
                    (fteTableTypes || []).map(el => <TableC
                        data={this.getDataSource(el)}
                        columns={this.getColumns(el)}
                        pagination={false}
                    />)
                }
                {((annualData.length !== 0 || nonBindAnnualData.length !== 0 ) && showAnnualData) && 
                    <div>
                        {
                            isBindAndNonBind ? <div>
                                <div style={{ 
                                    fontSize: 14,
                                    fontWeight: '700',
                                    margin: '10px 0',
                                }}>
                                    盲态服务年产出
                                </div>
                                <TableC
                                    data={annualData}
                                    columns={this.getAnnualColumns(isBindAndNonBind)}
                                    pagination={false}
                                />
                                <div style={{ 
                                    fontSize: 14,
                                    fontWeight: '700',
                                    margin: '10px 0',
                                }}>
                                    非盲服务年产出
                                </div>
                                <TableC
                                    data={nonBindAnnualData}
                                    columns={this.getNoBindAnnualColumns(isBindAndNonBind)}
                                    pagination={false}
                                />
                            </div> : <div>
                                <div style={{ 
                                    fontSize: 14,
                                    fontWeight: '700',
                                    margin: '10px 0',
                                }}>
                                    年产出
                                </div>
                                <TableC
                                    data={isBind ? annualData : nonBindAnnualData}
                                    columns={isBind ? this.getAnnualColumns() : this.getNoBindAnnualColumns()}
                                    pagination={false}
                                />
                            </div>
                        }
                    </div>
                }
                { showButn && <div className='Forecast_Params_footer'>
                    {
                        type === 'view'?
                        <Button
                            type="primary"
                            onClick={() => this.setState({
                                type: 'edit',
                            })}
                        >编辑</Button> :
                        <div>
                            <Button 
                                style={{ marginRight: 20 }}
                                onClick={() => this.setState({
                                    type: 'view',
                                }, () => this.loadData( evaluateRecordId ))}
                            >取消</Button>
                            <Button 
                                type="primary"
                                onClick={this.submit}
                            >保存</Button>
                        </div>
                    }
                </div>
            }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/FTEQuoteRule.js